<section class="help-faq" id="help-faq-section">
  <h2>Frequently asked <span class="accent">questions</span></h2>

  <div class="faq-list" *ngIf="filteredFaqs.length; else noResults">
    <div class="faq-item" *ngFor="let faq of filteredFaqs" [class.faq-item-open]="faq.open">
      <button class="faq-question" type="button" (click)="toggleFaq(faq)">
        <span>{{ faq.question }}</span>
        <span class="faq-icon">{{ faq.open ? '−' : '+' }}</span>
      </button>
      <div class="faq-answer" *ngIf="faq.open">
        <p>{{ faq.answer }}</p>
      </div>
    </div>
  </div>

  <ng-template #noResults>
    <p class="no-results">No results for "{{ searchTerm }}". Try a different search or use the contact options above.</p>
  </ng-template>
</section>
